module.exports = __webpack_public_path__ + "img/outlander-sport-red-compressor.9104b516.png";